import { Button, Typography } from "@mui/material";
import { Skeleton } from "@mui/material";
import { filter, map } from "lodash";
import { useEffect, useState } from "react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import CardInformacaoAssinatura from "./cardInformacaoAssinatura";
import { IconBriefcase } from "@tabler/icons-react";
import UsuarioDb from "../../../../db/usuarioDb";
import { onSnapshot, query, where } from "firebase/firestore";
import Business from "../../../../models/business";
import BusinessDb from "../../../../db/businessDb";
import Usuario from "../../../../models/usuario";
import { Link } from "react-router-dom";

export default function CardInformacoesBusiness() {
  const { usuario } = useUsuario();
  const [clientesAtivos, setClientesAtivos] = useState<Usuario[]>([]);
  const [business, setBusiness] = useState<Business>();

  useEffect(() => {
    if (usuario?.business)
      return onSnapshot(
        new BusinessDb().doc({ businessId: usuario?.business }),
        (snapshot) => {
          setBusiness(snapshot.data());
        }
      );
  }, [usuario?.business]);

  useEffect(() => {
    if (!!usuario?.business)
      return onSnapshot(
        query(
          new UsuarioDb().collection({ usuarioId: "" }),
          where("contaPai", "==", usuario?.business)
        ),
        (snapshot) => {
          setClientesAtivos(
            filter(
              map(snapshot.docs, (doc) => doc.data()),
              (cliente) => !!!cliente.arquivado
            )
          );
        }
      );
  }, [usuario?.business]);

  return (
    <CardInformacaoAssinatura
      titulo="Conta Business"
      Icone={IconBriefcase}
      conteudo={
        business && clientesAtivos ? (
          <>
            {"Você já criou "}
            <Typography variant="dataMono" fontSize={13} color="text.primary">
              {clientesAtivos.length}
            </Typography>
            {" de "}
            <Typography variant="dataMono" fontSize={13} color="text.primary">
              {business.quantidade}
            </Typography>
            {" contas contratadas."}
          </>
        ) : (
          <Skeleton variant="text" animation={false} />
        )
      }
      destaque={business?.nome ?? "-"}
      rodape={
        <Button
          component={Link}
          to="#business"
          variant="text"
          sx={{ color: "accentInk" }}
        >
          Gerenciar Conta Business
        </Button>
      }
    />
  );
}
